export const Abbreviate = (string) => {
    if (string === "Computer Science & Engineering") return "CSE";
    return string;
};

export const Roles = {
    MENTOR: "MENTOR",
    STUDENT: "STUDENT",
    ADMIN: "ADMIN",
};
